import { Subscription } from 'rxjs/Subscription';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsumidorModel, ConsumidorService } from '../../restrito/consumidor/shared/index';
import { CidadaoLgpd } from '../../restrito/consumidor/consumidor-lgpd/cidadao-lgpd';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})

export class MenuComponent implements OnInit, OnDestroy {

  public isCollapsed = true;
  public consumidorEdit = false;
  public unsubEditConsumidor: Subscription;
  private consumidorModel: ConsumidorModel;

  public buttonsDisabled = false;


  constructor(private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly consumidorService: ConsumidorService
  ) {
    this.consumidorModel = new ConsumidorModel();
  }


  ngOnInit() {
    this.consumidorEdit = this.consumidorService.getEditMode();
    this.unsubEditConsumidor = this.consumidorService.editModeChange
      .subscribe(
      (editMode: boolean) => {
        this.consumidorEdit = editMode;
        this.consumidorModel = this.consumidorService.getConsumidorModel();

        if(this.consumidorEdit) {
          this.DefinirStatusLgpdCidadao();
        }else{
          this.buttonsDisabled = false;
        }
        
      }
    );

    this.consumidorService.consumidorChange
      .subscribe(
      (consumidorModel) => {
        this.consumidorModel = consumidorModel;
      }
      );
  }

  private DefinirStatusLgpdCidadao() {
    if(!CidadaoLgpd.TermoLgpdAceito()) {
      this.buttonsDisabled = true;
    }else{
      this.buttonsDisabled = false;
    }
  }

  ngOnDestroy() {
    this.unsubEditConsumidor.unsubscribe();
  }

  onClickMenu(rota) {
    this.router.navigate([rota]);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-layout/menu/menu.component.ts